import { prefixObjectValues as pre } from '../../utils';
const prefix = 'training-table';
const table = pre(
  {
    addBtn: 'add-btn',
    row: 'row-',
    trainingType: 'training-credentials-',
    facilityName: 'facility-name-',
    facilityAddress: 'facility-address-',
    dates: 'dates-',
    completed: 'completed-',
    degree: 'degree-',
    editBtn: 'edit-btn-',
    deleteBtn: 'delete-btn-',
    specialtyBoard: 'specialty-board-',
    emptyState: 'empty-state',
  },
  prefix
);

export default table;
